import { useAppStore } from '@/store/app-store'

const PHONE_MAX_SHORT_SIDE_PX = 600

// phones only: shortest viewport side separates iPhone Pro Max (430) from iPad mini (744)
function detectIsPhone() {
    if (typeof window === 'undefined') {
        return false
    }
    return Math.min(window.innerWidth, window.innerHeight) < PHONE_MAX_SHORT_SIDE_PX
}

export function isHeroVideoAutoplayEnabled(): boolean {
    const appStore = useAppStore()

    return (
        appStore.platform !== 'desktop' &&
        appStore.isAppEnv &&
        appStore.experiments['hero-video-autoplay-exp']?.sample === 'app_autovideo_group_1' &&
        detectIsPhone()
    )
}
